export default "__VITE_ASSET__q9$6gCHw__"